/* The free 3D mock-up request, on its own page.

   Same request as the panel a product page opens, with the stand chosen here
   instead of carried in. Two selects — the stand, then the build — filled
   from the shop's own product feed, so the list never goes stale against the
   catalogue and nothing has to be maintained by hand in the theme.

   Artwork takes the same route as on a product page: Shopify's contact form
   carries no attachment, so each file is lodged in the shop's files (briefly
   as a cart line, removed the moment the URL comes back) and the message
   carries the links. Anything over Shopify's own 20 MB storefront ceiling is
   kept in the list, flagged, and named in the request so somebody can send an
   upload link for it — the request still goes. */
(function () {
  "use strict";

  var CEILING = 20 * 1024 * 1024;   /* Shopify's own, never shown as a number. */
  var STASH = "mp_mockup_page_pending";
  var SINK  = "mp-mockup-sink";

  /* Shopify's /contact answers a post with a redirect, so an ordinary form
     submit takes the whole page with it — the buyer is thrown onto another
     page and the panel they were filling in disappears. The post goes into a
     hidden frame instead: it is still a real form submit, which is what
     Shopify's captcha script binds to and what carries the token, but the
     reply lands in the frame and the page they are on never moves. The
     panel then says so itself. */
  function sink() {
    var f = document.getElementById(SINK);
    if (f) return f;
    f = document.createElement("iframe");
    f.id = SINK;
    f.name = SINK;
    f.setAttribute("aria-hidden", "true");
    f.setAttribute("tabindex", "-1");
    f.style.cssText = "position:absolute;width:0;height:0;border:0;left:-9999px";
    document.body.appendChild(f);
    return f;
  }

  /* A copy of every request into the sales sheet.

     The email through Shopify's /contact is what must not fail, so this is
     strictly a passenger: it is given two seconds and then abandoned,
     whatever happened, and the request goes on to Shopify either way. A
     studio that is missing a row still has the email; a customer whose
     request never sent has nothing, so the order of those two matters.

     mode "no-cors" with a text/plain body keeps this a simple request.
     Apps Script answers with no CORS headers at all, so anything that
     provokes a preflight — a JSON content type, a custom header — is
     refused by the browser before it ever leaves the page. */
  var SHEET_HOOK = "https://script.google.com/macros/s/AKfycbyDpVCjB0fpZyZyANjZKI7F-MHbh9QVY7xpHT4yR2BMLsyHtmePZCa1sreYlCGHVbkzYg/exec";
  var SHEET_SECRET = "mp-3d-KcIbrLIHebE-2026";

  function toSheet(form) {
    if (!SHEET_HOOK || !window.fetch) return Promise.resolve();
    var payload = { secret: SHEET_SECRET };
    Array.prototype.forEach.call(form.elements, function (el) {
      var n = el.getAttribute && el.getAttribute("name");
      if (!n || n.indexOf("contact[") !== 0) return;
      payload[n] = el.value || "";
    });
    return new Promise(function (done) {
      var settled = false;
      function finish() { if (settled) return; settled = true; done(); }
      window.setTimeout(finish, 2000);
      try {
        fetch(SHEET_HOOK, {
          method: "POST", mode: "no-cors", credentials: "omit",
          headers: { "Content-Type": "text/plain;charset=utf-8" },
          body: JSON.stringify(payload)
        }).then(finish, finish);
      } catch (err) { finish(); }
    });
  }

  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }

  function esc(s) {
    return String(s == null ? "" : s)
      .replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
  }
  function money(cents) {
    var n = Math.round(cents) / 100;
    return "$" + n.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }
  function size(bytes) {
    if (bytes >= 1048576) return (bytes / 1048576).toFixed(bytes >= 10485760 ? 0 : 1) + " MB";
    return Math.max(1, Math.round(bytes / 1024)) + " KB";
  }
  function cents(priceString) {
    var n = parseFloat(priceString);
    return isNaN(n) ? 0 : Math.round(n * 100);
  }

  /* The six ranges in the main menu, and nothing else. The shop's whole feed
     carries parts, samples and one-offs that nobody would ask us to render,
     so the list is built from the collections themselves — in menu order,
     under the names the menu uses. A stand that sits in two of them is
     listed once, under the first. */
  var RANGES = [
    { handle: "booths",           label: "Booths" },
    { handle: "backwalls",        label: "Backwalls" },
    { handle: "light-boxes",      label: "Light boxes" },
    { handle: "arches-entrances", label: "Arches" },
    { handle: "counters-towers",  label: "Counters" },
    { handle: "frames-parts",     label: "Frames & parts" }
  ];

  function loadRange(r) {
    var got = [];
    function page(n) {
      if (n > 4) return Promise.resolve(got);
      return fetch("/collections/" + r.handle + "/products.json?limit=250&page=" + n, {
        credentials: "same-origin", headers: { Accept: "application/json" }
      }).then(function (res) {
        if (!res.ok) throw new Error("feed");
        return res.json();
      }).then(function (j) {
        var batch = (j && j.products) || [];
        got = got.concat(batch);
        if (batch.length < 250) return got;
        return page(n + 1);
      });
    }
    return page(1).then(function (list) { return { range: r, products: list }; })
                  .catch(function () { return { range: r, products: [] }; });
  }

  /* The catalogue names. The raw Shopify titles are factory codes — "10x10ft
     Trade Show Booth Kit - B7" tells a buyer nothing about what is in the box
     — so the list is labelled with the same written names the collection
     cards carry, keyed by handle. */
  function loadNames(url) {
    if (!url) return Promise.resolve({});
    return fetch(url, { credentials: "same-origin", headers: { Accept: "application/json" } })
      .then(function (r) { if (!r.ok) throw new Error("names"); return r.json(); })
      .catch(function () { return {}; });
  }

  function loadProducts() {
    return Promise.all(RANGES.map(loadRange)).then(function (sets) {
      var any = sets.some(function (s) { return s.products.length; });
      if (!any) throw new Error("feed");
      return sets;
    });
  }

  function wire(root) {
    if (!root || root.dataset.mpk) return;
    root.dataset.mpk = "1";

    var form     = $("[data-mockup-form]", root);
    var prodSel  = $("[data-mockup-product]", root);
    var varWrap  = $("[data-mockup-buildwrap]", root);
    var varLabel = $("[data-mockup-buildlabel]", root);
    var varSel   = $("[data-mockup-variant]", root);
    var qtyIn    = $("[data-mockup-qty]", root);
    var whenIn   = $("[data-mockup-when]", root);
    var sumBox   = $("[data-mockup-sum]", root);
    var sumRows  = $("[data-sum-rows]", root);
    var sumSku   = $("[data-sum-sku]", root);
    var shotBox  = $("[data-sum-shot]", root);
    var prodNote = $("[data-mockup-prodnote]", root);
    var fileIn   = $("[data-mockup-file]", root);
    var drop     = $("[data-mockup-drop]", root);
    var listEl   = $("[data-mockup-files]", root);
    var bigBox   = $("[data-mockup-big]", root);
    var urlIn    = $("[data-mockup-fileurl]", root);
    var bigIn    = $("[data-mockup-bigin]", root);
    var errBox   = $("[data-mockup-err]", root);
    var live     = $("[data-mockup-live]", root);
    var done     = $("[data-mockup-done]", root);
    var doneLine = $("[data-mockup-doneline]", root);
    var foot     = $("[data-mockup-foot]", root);
    var send     = $("[data-mockup-send]", root);
    if (!form || !prodSel) return;

    var BOOK = {};   /* handle -> product */
    var NAMES = {};  /* handle -> the written catalogue name */

    function nameOf(p) { return (p && (NAMES[p.handle] || p.title)) || ""; }

    /* A show cannot be in the past, and we will not promise one that is days
       away. The product sheet uses the same floor. */
    if (whenIn && !whenIn.min) {
      var soon = new Date();
      soon.setDate(soon.getDate() + 2);
      whenIn.min = soon.toISOString().slice(0, 10);
    }

    /* ------------------------------------------------------- the list -- */

    function fillProducts(sets) {
      prodSel.innerHTML = "";
      var first = document.createElement("option");
      first.value = "";
      first.textContent = "Choose the stand you want rendered";
      prodSel.appendChild(first);

      var seen = {};
      sets.forEach(function (set) {
        var usable = set.products.filter(function (p) {
          if (!p || !p.variants || !p.variants.length) return false;
          if (seen[p.handle]) return false;
          if (!p.variants.some(function (v) { return cents(v.price) > 0; })) return false;
          seen[p.handle] = true;
          BOOK[p.handle] = p;
          return true;
        });
        if (!usable.length) return;

        var og = document.createElement("optgroup");
        og.label = set.range.label;
        usable.sort(function (a, b) { return nameOf(a).localeCompare(nameOf(b)); })
          .forEach(function (p) {
            var o = document.createElement("option");
            o.value = p.handle;
            o.textContent = nameOf(p);
            og.appendChild(o);
          });
        prodSel.appendChild(og);
      });

      /* Arriving from a stand's own page, or from a link that names one. */
      var want = "";
      try {
        var sp = new URLSearchParams(window.location.search);
        want = sp.get("stand") || sp.get("product") || "";
      } catch (e) {}
      if (want && BOOK[want]) { prodSel.value = want; onProduct(); }
    }

    function feedFailed() {
      /* The list could not be read. Rather than a dead select, the stand
         becomes something they can type, and the request still goes. */
      var box = prodSel.parentNode;
      var text = document.createElement("input");
      text.type = "text";
      text.id = prodSel.id;
      text.setAttribute("name", "contact[Stand]");
      text.placeholder = "Which stand, or describe what you need";
      box.replaceChild(text, prodSel);
      prodSel = text;
      if (varWrap) varWrap.hidden = true;
      if (prodNote) {
        prodNote.textContent = "Tell us the stand in your own words and we will match it.";
        prodNote.hidden = false;
      }
    }

    /* ------------------------------------------------- stand and build -- */

    function currentProduct() {
      return BOOK[prodSel && prodSel.value] || null;
    }
    function currentVariant() {
      var p = currentProduct();
      if (!p) return null;
      if (!varSel || !varSel.value) return p.variants[0] || null;
      for (var i = 0; i < p.variants.length; i++) {
        if (String(p.variants[i].id) === String(varSel.value)) return p.variants[i];
      }
      return p.variants[0] || null;
    }

    function onProduct() {
      var p = currentProduct();
      if (!p) {
        if (varWrap) varWrap.hidden = true;
        if (sumBox) sumBox.hidden = true;
        if (prodNote) prodNote.hidden = true;
        return;
      }

      var sellable = p.variants.filter(function (v) { return cents(v.price) > 0; });
      varSel.innerHTML = "";
      sellable.forEach(function (v) {
        var o = document.createElement("option");
        o.value = v.id;
        o.textContent = v.title + "  ·  " + money(cents(v.price))
          + (v.available ? "" : "  ·  made to order");
        varSel.appendChild(o);
      });

      /* The word above the select is the stand's own. A booth whose only
         choice is a size should not be asked to pick a "build". */
      var opt = (p.options || []).map(function (o) {
        return typeof o === "string" ? o : (o && o.name) || "";
      }).filter(Boolean).join(" and ");
      if (/^supply$/i.test(opt)) opt = "Build";
      else if (/^title$/i.test(opt) || !opt) opt = "Option";
      else if (/^size and supply$/i.test(opt)) opt = "Size and build";
      if (varLabel) varLabel.textContent = opt;

      if (varWrap) varWrap.hidden = sellable.length < 2;
      if (prodNote) prodNote.hidden = true;
      paint();
    }

    function paint() {
      var p = currentProduct();
      var v = currentVariant();
      if (!p || !v) { if (sumBox) sumBox.hidden = true; return; }

      var n = Math.max(1, parseInt(qtyIn && qtyIn.value, 10) || 1);
      var unit = cents(v.price);

      if (sumSku) sumSku.textContent = v.sku || "";

      var out = [];
      function row(k, val, cls) {
        out.push('<div class="mpq-row' + (cls ? " " + cls : "") + '"><i>' +
                 esc(k) + "</i><span>" + esc(val) + "</span></div>");
      }
      row("Stand", nameOf(p));
      if (v.title && !/^default title$/i.test(v.title)) row("Build", v.title);
      if (n > 1) row("Quantity", n);
      if (whenIn && whenIn.value) row("Show date", whenIn.value);
      row("Total", n > 1 ? (money(unit) + " each · " + money(unit * n)) : money(unit), "tot");
      if (sumRows) sumRows.innerHTML = out.join("");

      var img = (v.featured_image && v.featured_image.src)
        || ((p.images && p.images[0] && p.images[0].src) || "");
      if (shotBox) {
        var el = shotBox.querySelector("img");
        if (img && el) {
          el.src = img.replace(/(\.[a-z]+)(\?|$)/i, "_300x$1$2");
          el.alt = nameOf(p);
          shotBox.hidden = false;
        } else {
          shotBox.hidden = true;
        }
      }
      if (sumBox) sumBox.hidden = false;

      function put(q, val) { var el = $(q, root); if (el) el.value = val; }
      put("[data-sum-stand]", nameOf(p));
      put("[data-sum-build]", (v.title && !/^default title$/i.test(v.title)) ? v.title : "Only one build");
      put("[data-sum-skuin]", v.sku || "");
      put("[data-sum-qty]", String(n));
      put("[data-sum-total]", n > 1
        ? (money(unit) + " each, " + money(unit * n) + " for " + n)
        : money(unit));
      put("[data-sum-link]", window.location.origin + "/products/" + p.handle);
    }

    prodSel.addEventListener("change", onProduct);
    if (varSel) varSel.addEventListener("change", paint);
    if (qtyIn) qtyIn.addEventListener("input", paint);
    if (whenIn) whenIn.addEventListener("change", paint);

    /* ------------------------------------------------------- the files -- */

    var picked = [];

    var strip = document.createElement("p");
    strip.className = "mpq-status";
    strip.setAttribute("role", "status");
    strip.setAttribute("aria-live", "polite");
    strip.hidden = true;
    if (foot && foot.parentNode) foot.parentNode.insertBefore(strip, foot);

    function say(kind, msg) {
      if (!msg) {
        strip.hidden = true; strip.textContent = "";
        strip.removeAttribute("data-kind"); return;
      }
      strip.textContent = msg;
      strip.setAttribute("data-kind", kind);
      strip.hidden = false;
    }

    function flag(el) {
      if (!el) return;
      el.classList.add("is-bad");
      if (el.scrollIntoView) el.scrollIntoView({ block: "center" });
      try { el.focus(); } catch (e) {}
      var ev = el.tagName === "SELECT" ? "change" : "input";
      el.addEventListener(ev, function clear() {
        el.classList.remove("is-bad");
        say("", "");
        el.removeEventListener(ev, clear);
      });
    }

    function render() {
      listEl.innerHTML = "";
      picked.forEach(function (p) {
        var li = document.createElement("li");
        li.className = "mpq-file";
        li.dataset.state = p.big ? "big" : (p.url ? "up" : "new");
        li.innerHTML =
          '<span class="dot" aria-hidden="true"></span>' +
          '<span class="nm"></span>' +
          '<span class="sz">' + size(p.file.size) + "</span>" +
          '<button type="button" class="rm" aria-label="Remove">&times;</button>';
        li.querySelector(".nm").textContent = p.file.name;
        li.querySelector(".rm").addEventListener("click", function () {
          var at = picked.indexOf(p);
          if (at > -1) picked.splice(at, 1);
          render();
        });
        listEl.appendChild(li);
      });

      var big = picked.filter(function (p) { return p.big; });
      if (!bigBox) return;
      if (!big.length) { bigBox.hidden = true; return; }
      bigBox.textContent = (big.length === 1 ? "One file is" : big.length + " files are")
        + " too large to travel with this form. Leave it in the list — we will email you"
        + " an upload link for it, and the request still goes through now.";
      bigBox.hidden = false;
    }

    function take(files) {
      Array.prototype.forEach.call(files || [], function (f) {
        var dupe = picked.some(function (p) {
          return p.file.name === f.name && p.file.size === f.size;
        });
        if (!dupe) picked.push({ file: f, big: f.size > CEILING, url: "" });
      });
      render();
      if (errBox) errBox.hidden = true;
    }

    if (fileIn) {
      fileIn.addEventListener("change", function () {
        take(fileIn.files);
        fileIn.value = "";
      });
    }
    if (drop) {
      ["dragenter", "dragover"].forEach(function (ev) {
        drop.addEventListener(ev, function (e) {
          e.preventDefault(); e.stopPropagation(); drop.classList.add("over");
        });
      });
      ["dragleave", "dragend"].forEach(function (ev) {
        drop.addEventListener(ev, function (e) {
          e.preventDefault(); e.stopPropagation(); drop.classList.remove("over");
        });
      });
      drop.addEventListener("drop", function (e) {
        e.preventDefault(); e.stopPropagation(); drop.classList.remove("over");
        take(e.dataTransfer && e.dataTransfer.files);
      });
    }

    function uploadViaCart(variantId, file) {
      var fd = new FormData();
      fd.append("id", variantId);
      fd.append("quantity", "1");
      fd.append("properties[_mp_mockup_file]", file, file.name);
      return fetch("/cart/add.js", {
        method: "POST", credentials: "same-origin",
        headers: { Accept: "application/json" }, body: fd
      }).then(function (r) {
        if (!r.ok) throw new Error("upload");
        return r.json();
      }).then(function (data) {
        var item = (data.items && data.items[0]) || data;
        var url = (item.properties || {})._mp_mockup_file || "";
        var key = item.key;
        if (!key) return url;
        return fetch("/cart/change.js", {
          method: "POST", credentials: "same-origin",
          headers: { "Content-Type": "application/json", Accept: "application/json" },
          body: JSON.stringify({ id: key, quantity: 0 })
        }).then(function () { return url; });
      });
    }

    /* ------------------------------------------------------- delivery -- */

    var armed = false;

    form.addEventListener("submit", function (e) {
      if (armed) return;   /* The browser and Shopify's captcha own it now. */
      e.preventDefault();
      if (errBox) { errBox.hidden = true; errBox.textContent = ""; }

      var nameIn  = $('input[name="contact[name]"]', form);
      var emailIn = $('input[name="contact[email]"]', form);
      var revert  = send.textContent;

      function fail(msg, el) {
        say("bad", msg);
        if (errBox) { errBox.textContent = msg; errBox.hidden = false; }
        send.disabled = false;
        send.textContent = revert || "Send my request";
        flag(el);
      }

      if (prodSel.tagName === "SELECT" && !prodSel.value) {
        fail("Choose the stand you would like us to render.", prodSel); return;
      }
      if (prodSel.tagName !== "SELECT" && !prodSel.value.trim()) {
        fail("Tell us which stand you would like us to render.", prodSel); return;
      }
      if (!nameIn.value.trim()) {
        fail("Tell us your name so we know who we are writing to.", nameIn); return;
      }
      if (!emailIn.value.trim() || emailIn.value.indexOf("@") < 1) {
        fail("We need an email address to send the mock-up to.", emailIn); return;
      }

      paint();

      send.disabled = true;
      say("busy", "Sending your request…");

      var v = currentVariant();
      var queue = picked.filter(function (p) { return !p.big && !p.url; });
      var step = 0;

      function next() {
        if (!v || step >= queue.length) return Promise.resolve();
        var p = queue[step];
        send.textContent = queue.length > 1
          ? ("Uploading " + (step + 1) + " of " + queue.length + "…")
          : "Uploading…";
        return uploadViaCart(v.id, p.file)
          .then(function (url) { p.url = url || ""; })
          .catch(function () { p.big = true; })
          .then(function () { step += 1; render(); return next(); });
      }

      next().then(function () {
        var urls = picked.filter(function (p) { return p.url; })
                         .map(function (p) { return p.file.name + " — " + p.url; });
        var later = picked.filter(function (p) { return p.big; })
                          .map(function (p) { return p.file.name + " (" + size(p.file.size) + ")"; });
        if (urlIn) urlIn.value = urls.length ? urls.join("\n") : "None attached";
        if (bigIn) bigIn.value = later.length ? ("Send an upload link for: " + later.join(", ")) : "";
        send.textContent = "Sending…";

        try {
          window.sessionStorage.setItem(STASH, JSON.stringify({
            path: window.location.pathname,
            email: emailIn.value.trim()
          }));
        } catch (err) {}

        say("busy", "Finishing your request — one moment…");

        return toSheet(form);
      }).then(function () {
        var frame = sink();
        var settled = false;

        function landed() {
          if (settled) return;
          settled = true;
          window.clearTimeout(guard);
          frame.removeEventListener("load", landed);
          showSent(emailIn.value.trim());
        }

        /* If the captcha challenge is closed rather than answered the frame
           never loads, so the button is given back rather than left dead. */
        var guard = window.setTimeout(function () {
          if (settled) return;
          settled = true;
          frame.removeEventListener("load", landed);
          send.disabled = false;
          send.textContent = revert || "Send my request";
          say("", "");
        }, 25000);

        frame.addEventListener("load", landed);
        form.target = SINK;

        armed = true;
        /* requestSubmit, never submit: submit() is the method and raises no
           event, so Shopify's captcha script never sees it. */
        if (form.requestSubmit) { form.requestSubmit(); }
        else {
          armed = false;
          settled = true;
          window.clearTimeout(guard);
          form.target = "";
          fail("That did not send. Email sales@megaprintery.com and we will pick it up from there.");
        }
      }).catch(function () {
        fail("That did not send. Email sales@megaprintery.com and we will pick it up from there.");
      });
    });

    function showSent(email) {
      if (live) live.hidden = true;
      if (foot) foot.hidden = true;
      if (strip) strip.hidden = true;
      if (doneLine) {
        doneLine.textContent = "Your 3D mock-up request has been submitted.";
      }
      if (done) done.hidden = false;
      if (done && done.scrollIntoView) done.scrollIntoView({ block: "center" });
    }

    /* Shopify brings them back with contact_posted=true. This only runs now
       where the post could not go into the frame — no JavaScript on the
       first pass, or a browser that ignored the target. */
    function settle() {
      if (window.location.search.indexOf("contact_posted=true") < 0) return;
      var raw = null;
      try { raw = window.sessionStorage.getItem(STASH); } catch (e) {}
      var st = null;
      if (raw) {
        try { window.sessionStorage.removeItem(STASH); } catch (e) {}
        try { st = JSON.parse(raw); } catch (e) { st = null; }
      }
      showSent(st && st.email);

      if (window.history && history.replaceState && window.URLSearchParams) {
        var sp = new URLSearchParams(window.location.search);
        sp.delete("contact_posted");
        sp.delete("form_type");
        var qs = sp.toString();
        history.replaceState(null, "", window.location.pathname + (qs ? "?" + qs : ""));
      }
    }

    loadNames(root.getAttribute("data-names"))
      .then(function (map) { NAMES = map || {}; return loadProducts(); })
      .then(fillProducts)
      .catch(feedFailed);
    settle();
  }

  /* ------------------------------------------------------- the dialog -- */
  /* The page at /pages/3d-mockup stays exactly where it is: it is the
     fallback with JavaScript off, the thing a search engine indexes, and what
     a link in an email can point at. Where this script runs and the dialog is
     on the page, a click on any link to that page opens the dialog instead,
     because somebody who presses "Get a Free 3D Mockup" is asking to send us
     their artwork, not asking to be taken somewhere else to do it. */
  var MOCKUP_PATH = "/pages/3d-mockup";

  function modal() { return $("[data-mockup-modal]"); }

  function openModal(stand) {
    var dlg = modal();
    if (!dlg) return false;
    wire($("[data-mockup-page]", dlg));
    if (stand) {
      var sel = $("[data-mockup-product]", dlg);
      if (sel && sel.tagName === "SELECT") {
        for (var i = 0; i < sel.options.length; i++) {
          if (sel.options[i].value === stand) {
            sel.value = stand;
            sel.dispatchEvent(new Event("change", { bubbles: true }));
            break;
          }
        }
      }
    }
    if (!dlg.open) { if (dlg.showModal) dlg.showModal(); else dlg.setAttribute("open", ""); }
    var first = $("[data-mockup-product]", dlg);
    if (first) window.setTimeout(function () { try { first.focus(); } catch (e) {} }, 80);
    return true;
  }

  function closeModal() {
    var dlg = modal();
    if (!dlg) return;
    if (dlg.close) dlg.close(); else dlg.removeAttribute("open");
  }

  function wireModal() {
    var dlg = modal();
    if (!dlg || dlg.dataset.mpkm) return;
    dlg.dataset.mpkm = "1";
    $$("[data-mockup-modalclose]", dlg).forEach(function (b) {
      b.addEventListener("click", closeModal);
    });
    /* A click on the backdrop. The panel fills the dialog, so anything that
       lands on the dialog itself is outside the panel. */
    dlg.addEventListener("click", function (e) { if (e.target === dlg) closeModal(); });
  }

  document.addEventListener("click", function (e) {
    var a = e.target && e.target.closest ? e.target.closest("a[href]") : null;
    if (!a) return;
    if (e.defaultPrevented || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    if (a.target && a.target !== "_self") return;
    var href = a.getAttribute("href") || "";
    if (href.indexOf(MOCKUP_PATH) < 0) return;
    /* Already on the page itself — let the link be. */
    if (window.location.pathname.indexOf(MOCKUP_PATH) === 0) return;
    var stand = "";
    try { stand = new URL(a.href, window.location.origin).searchParams.get("stand") || ""; } catch (err) {}
    if (openModal(stand)) e.preventDefault();
  });

  function boot() {
    $$("[data-mockup-page]").forEach(function (r) {
      /* The copy inside the dialog is wired when the dialog first opens, so
         its product feed is not fetched on every page view. */
      if (r.closest && r.closest("[data-mockup-modal]")) return;
      wire(r);
    });
    wireModal();
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
  else boot();
  document.addEventListener("shopify:section:load", boot);
})();
